export default "__VITE_ASSET__VSRkeZFO__"